import * as React from 'react';
import { useState } from 'react';
import { Select, SelectProps, Spin } from 'antd';
import { observer } from 'mobx-react';
import { DriverAdminStore } from '../../stores/Admin/DriverAdminStore';

interface Props extends SelectProps {
    onChange?: (value: any) => void;
}
let busy: any;

const DriversPicker = (props: Props) => {
    const [loading, setLoading] = useState(false);

    const drivers = DriverAdminStore.drivers;

    return (
        <Select
            showSearch
            allowClear
            labelInValue
            style={{ width: '100%' }}
            dropdownMatchSelectWidth={false}
            placeholder="Rusher"
            optionFilterProp="children"
            filterOption={(input, option: any) =>
                (option?.props?.children ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            notFoundContent={loading ? <Spin size="small" /> : null}
            onSearch={name => {
                if (busy) {
                    clearTimeout(busy);
                }
                const params = {
                    search: name,
                };

                setLoading(true);

                busy = setTimeout(() => DriverAdminStore.getDrivers(params), 800);
            }}
            {...props}
        >
            {drivers.map(entity => (
                <Select.Option key={entity.uid} value={entity.uid}>
                    {`${entity.first_name} ${entity.last_name}`}
                </Select.Option>
            ))}
        </Select>
    );
};

export default observer(DriversPicker);
